module.exports = __webpack_public_path__ + "static/media/close_arrow.68638394.svg";